/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StateTown } from './StateTown';
import {
    StateTownFromJSON,
    StateTownFromJSONTyped,
    StateTownToJSON,
} from './StateTown';

/**
 * 
 * @export
 * @interface OrganizationStateTown
 */
export interface OrganizationStateTown {
    /**
     * 
     * @type {string}
     * @memberof OrganizationStateTown
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStateTown
     */
    organization_state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStateTown
     */
    state_town_id?: string;
    /**
     * 
     * @type {StateTown}
     * @memberof OrganizationStateTown
     */
    state_town?: StateTown;
}

/**
 * Check if a given object implements the OrganizationStateTown interface.
 */
export function instanceOfOrganizationStateTown(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrganizationStateTownFromJSON(json: any): OrganizationStateTown {
    return OrganizationStateTownFromJSONTyped(json, false);
}

export function OrganizationStateTownFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationStateTown {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'organization_state_id': !exists(json, 'organization_state_id') ? undefined : json['organization_state_id'],
        'state_town_id': !exists(json, 'state_town_id') ? undefined : json['state_town_id'],
        'state_town': !exists(json, 'state_town') ? undefined : StateTownFromJSON(json['state_town']),
    };
}

export function OrganizationStateTownToJSON(value?: OrganizationStateTown | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_state_id': value.organization_state_id,
        'state_town_id': value.state_town_id,
        'state_town': StateTownToJSON(value.state_town),
    };
}

